import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './profiler.css';
import SocialDetails from '../Components/SocialDetails';
import FamilyDetails from '../Components/FamilyDetails';
import RecreationDetails from '../Components/RecreationDetails';

function KnowYouBetter() {
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Box
      sx={{
        padding: 5,
      }}>
      <Accordion
        expanded={expanded === 'panel1'}
        onChange={handleChange('panel1')}
        sx={{
          marginBottom: 1.5,
        }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
          sx={{
            padding: 1,
            paddingLeft: 2,
            paddingRight: 2,
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <div className='pro-vertical-block' />

            <Typography fontWeight={'600'}>Personal Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <SocialDetails
            expanded={expanded === 'panel1'}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === 'panel2'}
        onChange={handleChange('panel2')}
        sx={{
          marginBottom: 1.5,
        }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
          sx={{
            padding: 1,
            paddingLeft: 2,
            paddingRight: 2,
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <div className='pro-vertical-block' />

            <Typography fontWeight={'600'}>Family Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <FamilyDetails
            expanded={expanded === 'panel2'}
          />
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={expanded === 'panel3'}
        onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1-content'
          id='panel1-header'
          sx={{
            padding: 1,
            paddingLeft: 2,
            paddingRight: 2,
          }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <div className='pro-vertical-block' />

            <Typography fontWeight={'600'}>Recreation Details</Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <RecreationDetails
            expanded={expanded === 'panel3'}
          />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default KnowYouBetter;
